import { Component, OnInit, Inject } from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { Store, ValidationPreview } from 'src/app/interfaces';
import { VerificationChargeInfoComponent } from '../verification-charge-info/verification-charge-info.component';
import { UtilsService } from 'src/app/services/utils.service';

export interface ConfirmOpenData {
  requireSecurityCode: boolean;
  securityCode: string;
  transactionsCount: number;
  store: Store;
  validationPreview: ValidationPreview | null;
}

@Component({
  selector: 'app-confirm-open',
  templateUrl: './confirm-open.component.html',
  styleUrls: ['./confirm-open.component.scss']
})
export class ConfirmOpenComponent implements OnInit {

  requireSecurityCode: boolean;
  securityCode: string;
  transactionsCount: number;
  store: Store;
  validationPreview: ValidationPreview | null;

  constructor(
    public utils: UtilsService,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmOpenData) {
      this.transactionsCount = data.transactionsCount;
      this.store = data.store;
      this.requireSecurityCode = data.requireSecurityCode;
      this.securityCode = data.securityCode;
      this.validationPreview = data.validationPreview;
  }

  ngOnInit(): void {
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(VerificationChargeInfoComponent);
    dialogRef.afterClosed().subscribe(result => {
      console.log("closed")
    });
  }

  close() {
    this.dialogRef.close();
  }

  confirmOpen() {
    this.dialogRef.close({securityCode: this.securityCode});
  }

}
